import React from 'react';

// Shared page header for content pages so Features / FAQ / How-to share the
// exact same title scale, spacing and subtitle rhythm.
const PageHero = ({ title, subtitle }) => (
  <div className="text-center max-w-3xl mx-auto mb-12 sm:mb-16">
    <h1 className="heading-hero">{title}</h1>
    {subtitle && <p className="mt-4 text-lg text-gray-600">{subtitle}</p>}
  </div>
);

export default PageHero;
